var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_85257",
    "data-name": "Group 85257",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 562.85,
    height: 519,
    viewBox: "0 0 562.85 519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24868",
    "data-name": "Rectangle 24868",
    width: 562.85,
    height: 519,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85256",
    "data-name": "Group 85256",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241258",
    "data-name": "Path 241258",
    d: "M115.289,350.477,56.834,170.571A36.913,36.913,0,0,1,70.246,129.3L223.281,18.115a36.906,36.906,0,0,1,43.395,0L419.71,129.3a36.913,36.913,0,0,1,13.412,41.27L374.666,350.477a36.91,36.91,0,0,1-35.106,25.507H150.4a36.91,36.91,0,0,1-35.106-25.507",
    transform: "translate(127.919 25.719)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241259",
    "data-name": "Path 241259",
    d: "M214.125,497.294H41.913A34.11,34.11,0,0,1,7.841,463.222V42.205A34.112,34.112,0,0,1,41.913,8.13H214.125A34.112,34.112,0,0,1,248.2,42.205V463.222a34.11,34.11,0,0,1-34.072,34.072M41.913,21.243A20.987,20.987,0,0,0,20.95,42.205V463.222a20.989,20.989,0,0,0,20.963,20.963H214.125a20.986,20.986,0,0,0,20.959-20.963V42.205a20.984,20.984,0,0,0-20.959-20.963Z",
    transform: "translate(18.228 18.9)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241260",
    "data-name": "Path 241260",
    d: "M210.442,486.154H36.428A26.615,26.615,0,0,1,9.813,459.539V36.718A26.615,26.615,0,0,1,36.428,10.1H210.442a26.615,26.615,0,0,1,26.615,26.615V459.539a26.615,26.615,0,0,1-26.615,26.615",
    transform: "translate(22.813 23.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24863",
    "data-name": "Rectangle 24863",
    width: 224.317,
    height: 318.82,
    transform: "translate(34.095 114.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241261",
    "data-name": "Path 241261",
    d: "M235.9,354.648H10.02V34.269H235.9ZM11.583,353.089H234.341V35.828H11.583Z",
    transform: "translate(23.294 79.667)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241262",
    "data-name": "Path 241262",
    d: "M205.153,250.174V78.873s-48.445,76.6-98.532,84.994C30.929,176.557,22.91,250.174,22.91,250.174Z",
    transform: "translate(53.26 183.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241263",
    "data-name": "Path 241263",
    d: "M206.541,252.836H22.649l.093-.864c.08-.741,8.954-74.348,84.359-86.992,49.166-8.242,97.518-83.877,98-84.641l1.44-2.274Zm-182.13-1.559h180.57V83.364c-8.438,12.621-52.568,75.6-97.625,83.155-69.8,11.7-81.709,76.482-82.946,84.758",
    transform: "translate(52.653 181.479)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241264",
    "data-name": "Path 241264",
    d: "M10.255,34.5V205.8s48.445-76.6,98.532-84.994C184.479,108.12,192.5,34.5,192.5,34.5Z",
    transform: "translate(23.84 80.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241265",
    "data-name": "Path 241265",
    d: "M10.02,209.041V34.269H193.909l-.093.864c-.08.741-8.954,74.348-84.352,86.992-49.166,8.245-97.522,83.88-98,84.645ZM11.583,35.828V203.745c8.438-12.621,52.564-75.6,97.618-83.155C179,108.883,190.91,44.1,192.146,35.828Z",
    transform: "translate(23.294 79.667)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241266",
    "data-name": "Path 241266",
    d: "M25.972,21.366A5.672,5.672,0,1,1,20.3,15.694a5.673,5.673,0,0,1,5.672,5.672",
    transform: "translate(34.006 36.485)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241267",
    "data-name": "Path 241267",
    d: "M31.091,21.366a5.672,5.672,0,1,1-5.672-5.672,5.673,5.673,0,0,1,5.672,5.672",
    transform: "translate(45.907 36.485)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241268",
    "data-name": "Path 241268",
    d: "M36.212,21.366a5.674,5.674,0,1,1-5.675-5.672,5.676,5.676,0,0,1,5.675,5.672",
    transform: "translate(57.805 36.485)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241269",
    "data-name": "Path 241269",
    d: "M60.485,152.815a18.5,18.5,0,1,1-18.5-18.5,18.5,18.5,0,0,1,18.5,18.5",
    transform: "translate(54.587 312.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241270",
    "data-name": "Path 241270",
    d: "M42.53,172.643a19.282,19.282,0,1,1,19.284-19.283A19.306,19.306,0,0,1,42.53,172.643m0-37A17.721,17.721,0,1,0,60.25,153.359,17.741,17.741,0,0,0,42.53,135.638",
    transform: "translate(54.041 311.7)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241271",
    "data-name": "Path 241271",
    d: "M74.686,152.815a18.5,18.5,0,1,1-18.5-18.5,18.5,18.5,0,0,1,18.5,18.5",
    transform: "translate(87.601 312.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241272",
    "data-name": "Path 241272",
    d: "M56.731,172.643a19.282,19.282,0,1,1,19.284-19.283,19.306,19.306,0,0,1-19.284,19.283m0-37a17.721,17.721,0,1,0,17.721,17.721,17.741,17.741,0,0,0-17.721-17.721",
    transform: "translate(87.055 311.7)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241273",
    "data-name": "Path 241273",
    d: "M88.887,152.815a18.5,18.5,0,1,1-18.5-18.5,18.5,18.5,0,0,1,18.5,18.5",
    transform: "translate(120.615 312.244)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241274",
    "data-name": "Path 241274",
    d: "M54.563,141.556v-2.414H53.13v2.414a5.227,5.227,0,1,1-10.453,0v-2.414H41.244v2.414a6.667,6.667,0,0,0,5.945,6.62v3.408h-5.16v1.433H53.915v-1.433h-5.3v-3.408a6.667,6.667,0,0,0,5.945-6.62",
    transform: "translate(95.882 323.47)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241275",
    "data-name": "Path 241275",
    d: "M45.462,150.923a3.168,3.168,0,0,0,3.168-3.168v-8.142a3.168,3.168,0,1,0-6.337,0v8.142a3.168,3.168,0,0,0,3.169,3.168",
    transform: "translate(98.323 317.189)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241276",
    "data-name": "Path 241276",
    d: "M61.068,145.4,54.6,147.055c-.386.1-.758-.276-.825-.845l-.539-4.485a1.07,1.07,0,0,1,.578-1.2l7.118-1.829c.446-.113.851.4.835,1.061l-.106,4.651a.994.994,0,0,1-.588.991",
    transform: "translate(123.724 322.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241277",
    "data-name": "Path 241277",
    d: "M59.8,145.554l6.473,1.659c.386.1.758-.276.825-.844l.539-4.485a1.07,1.07,0,0,0-.578-1.2l-7.118-1.829c-.446-.113-.851.4-.835,1.061l.106,4.651a.994.994,0,0,0,.588.991",
    transform: "translate(137.406 322.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241278",
    "data-name": "Path 241278",
    d: "M79.793,146.91c-.066-.05-6.676-4.994-12.684-4.994-6.064,0-12.684,4.269-12.75,4.312l-1.044-3.807c.293-.193,7.155-4.492,13.794-4.492,6.683,0,13.339,4.748,13.631,4.971Z",
    transform: "translate(123.944 320.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241279",
    "data-name": "Path 241279",
    d: "M43.924,151.1H26.635a1.159,1.159,0,0,1-1.16-1.16V139.122a1.159,1.159,0,0,1,1.16-1.157H43.924a1.159,1.159,0,0,1,1.16,1.157v10.815a1.159,1.159,0,0,1-1.16,1.16",
    transform: "translate(59.223 320.734)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241280",
    "data-name": "Path 241280",
    d: "M34.627,146.892l-2.617-1.742a.918.918,0,0,1-.406-.761v-3.212a.918.918,0,0,1,.406-.761l2.617-1.742a.913.913,0,0,1,1.42.758v6.7a.913.913,0,0,1-1.42.758",
    transform: "translate(73.474 322.02)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241281",
    "data-name": "Path 241281",
    d: "M22.408,86.242c.083-12.707,11.121-48.684,23.363-45.27,9.881,2.756,26.445,15.467,33.723,31.7,6.4,14.263-13.382,30.179,21.917,48.924s26.525,70.94-27.1,53.655c-40.263-12.977-52.122-55.261-51.9-89.007",
    transform: "translate(52.086 94.721)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241282",
    "data-name": "Path 241282",
    d: "M108.412,135.212h0a18.777,18.777,0,0,1-26.575.446L28.7,84.54A18.806,18.806,0,0,1,54.83,57.489l53.139,51.118a18.831,18.831,0,0,1,.442,26.6",
    transform: "translate(53.397 121.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241283",
    "data-name": "Path 241283",
    d: "M95.437,142.271a19.458,19.458,0,0,1-13.6-5.509L28.7,85.647a19.638,19.638,0,0,1-.465-27.712,19.562,19.562,0,0,1,27.679-.462l53.139,51.115a19.635,19.635,0,0,1,.462,27.712,19.409,19.409,0,0,1-14.074,5.971M42.3,53.523a17.858,17.858,0,0,0-12.95,5.5,18.072,18.072,0,0,0,.422,25.5l53.139,51.115a18.025,18.025,0,1,0,25.049-25.926L54.829,58.6A17.921,17.921,0,0,0,42.3,53.523",
    transform: "translate(52.86 120.803)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241284",
    "data-name": "Path 241284",
    d: "M87.145,92.752,68.283,99.657,59.875,76.59l7.923-2.9,3.069-9a6.429,6.429,0,0,1,3.877-3.96l4.086-1.5a2.915,2.915,0,0,1,2.686,5.12,3.253,3.253,0,0,1-.775.439c.479-.093,8.082-1.586,9.15-5.11a3.026,3.026,0,0,0,.116-.588,2.5,2.5,0,0,1,1.629-2.148,2.475,2.475,0,0,1,3.318,2.543L92.75,85.4a8.6,8.6,0,0,1-5.606,7.351",
    transform: "translate(139.194 132.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241285",
    "data-name": "Path 241285",
    d: "M68.514,101.2l-8.94-24.533,8.305-3.039,2.949-8.644a7.169,7.169,0,0,1,4.345-4.445l4.083-1.5a3.7,3.7,0,0,1,4.867,2.567,3.572,3.572,0,0,1-.153,2.274c2.563-.8,5.34-2.128,5.872-3.887a2.24,2.24,0,0,0,.086-.426,3.262,3.262,0,0,1,2.138-2.816,3.3,3.3,0,0,1,3.528.864,3.2,3.2,0,0,1,.835,2.48l-2.2,25.91a9.416,9.416,0,0,1-6.118,8.016Zm-6.942-23.6,7.873,21.6,18.13-6.636a7.844,7.844,0,0,0,5.1-6.683l2.2-25.916a1.67,1.67,0,0,0-.432-1.293A1.709,1.709,0,0,0,91.482,59.7a3.762,3.762,0,0,1-.143.728c-1.147,3.79-8.319,5.383-9.748,5.662l-.449-1.486a2.481,2.481,0,0,0,.6-.336A2.151,2.151,0,0,0,82.615,62a2.184,2.184,0,0,0-2.823-1.5L75.709,62A5.627,5.627,0,0,0,72.3,65.482l-3.188,9.349Z",
    transform: "translate(138.495 131.483)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241286",
    "data-name": "Path 241286",
    d: "M117.647,85.634s-30.588,19.247-47.321,27.24c-2.194,1.054-4.159,1.908-5.772,2.5-11.43,4.179-20.537-1.45-24.1-11.214A18.824,18.824,0,0,1,51.674,80.026l52.757-16,4.8-1.456Z",
    transform: "translate(91.387 145.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241287",
    "data-name": "Path 241287",
    d: "M57.682,118.218c-7.9,0-14.413-4.907-17.415-13.123A19.606,19.606,0,0,1,51.953,79.964l58.3-17.678,8.887,24.344-.535.336c-.306.193-30.817,19.36-47.4,27.283-2.287,1.1-4.256,1.948-5.842,2.527a22.428,22.428,0,0,1-7.687,1.443M109.3,64.208,52.449,81.443A18.044,18.044,0,0,0,41.733,104.56c2.766,7.574,8.727,12.1,15.949,12.1a20.8,20.8,0,0,0,7.152-1.35c1.539-.562,3.461-1.393,5.705-2.467,15.291-7.308,42.553-24.267,46.706-26.864Z",
    transform: "translate(90.838 144.799)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241288",
    "data-name": "Path 241288",
    d: "M83.487,93.318S65.56,175.273,48.052,204.145v.007a41.032,41.032,0,0,1-4.093,5.735l-12.172-8.651-6.068-4.306L10.256,185.942V124.78l.791-1.865,5.536-13.006,1.273-2.989L24.4,91.543v-.007l2.324-5.463,2.317-5.446.323-.761,1.732.429,19.822,4.927L59.2,87.28H59.2L67.319,89.3Z",
    transform: "translate(23.843 185.668)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241289",
    "data-name": "Path 241289",
    d: "M29.812,171V171a34.565,34.565,0,0,1-3.647,6.919c-.585.864-1.207,1.709-1.878,2.517A35.1,35.1,0,0,1,12.1,189.955l-1.842.864V110.6c.259-.14.509-.283.768-.422,5.492-2.972,11.065-5.918,16.634-8.781l4.129,49.795.342,4.086A34.953,34.953,0,0,1,29.812,171",
    transform: "translate(23.843 235.716)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241290",
    "data-name": "Path 241290",
    d: "M67.541,91.25l-.223,1.31-.037.236L50.243,194.35l-.173,1.014-.382,2.3L48.052,207.4v.007L42.5,240.5l-1.785,10.626H10.256V80.714c.053-.053.1-.1.146-.15.319-.309.6-.585.861-.828.918-.858,1.433-1.273,1.433-1.273l.881.209,3.361.775v.007l2.248.519,10.679,2.494,1.752.409,19.26,4.492,6.244,1.456Z",
    transform: "translate(23.843 182.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241291",
    "data-name": "Path 241291",
    d: "M41.922,252.5h-31.9V80.973l.376-.366c.329-.322.612-.6.874-.848.951-.888,1.483-1.313,1.483-1.313l.3-.236L68.979,91.246,68.6,93.507ZM11.58,250.937H40.6l26.591-158.5L13.442,79.9c-.233.2-.608.532-1.1.994-.229.216-.479.459-.758.731Z",
    transform: "translate(23.296 181.819)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241292",
    "data-name": "Path 241292",
    d: "M22.586,77.376c-1.15,2.776-2.291,5.549-3.4,8.338C19,86.2,18.8,86.7,18.6,87.188q-1.132,2.853-2.234,5.705-.569,1.466-1.134,2.946-2.573,6.748-4.98,13.5v-6.756q1.431-3.87,2.909-7.747c.665-1.739,1.34-3.484,2.028-5.223.376-.984.768-1.962,1.16-2.946.2-.489.386-.984.588-1.473V85.19c1.107-2.789,2.238-5.562,3.385-8.338a1.327,1.327,0,0,1,1.074-.844h.013a1.241,1.241,0,0,1,.868.193h.007a.908.908,0,0,1,.3,1.177",
    transform: "translate(23.84 176.668)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241293",
    "data-name": "Path 241293",
    d: "M96.36,109.679l-.03.126-.043.176-.133.572L92.78,125.039l-1.6,6.852-.17.748-5.143,22.026-.17.748-2.211,9.509-16.2-3.78-7.534-1.755-8.811-2.058L30.58,152.588l-1.539-.356-.213-.053L18.6,149.792l-2.251-.519-2.271-.532-2.819-.658-1-.239V111.478l2.567-11.025L13,99.681h.007l.306-1.323,6.763-28.992,1.553-6.673.18-.748.678-2.929a12.857,12.857,0,0,1,5.064-7.564c.219-.153.442-.3.672-.442.156-.1.313-.193.475-.283a10.327,10.327,0,0,1,1.1-.555c.18-.08.362-.153.549-.229a13.29,13.29,0,0,1,1.666-.525c.146-.037.286-.067.436-.1.1-.02.213-.043.319-.066.153-.02.316-.05.472-.066.206-.03.416-.05.622-.073s.422-.037.628-.043h.073a12.819,12.819,0,0,1,3.368.332l.273.067c.223.043.452.1.675.156l.043.013,19.822,4.618L74.5,57.929l.1.02,1.619.379c.186.043.362.09.549.14a2.713,2.713,0,0,1,.309.09c.176.043.356.1.525.163l.379.133a4.452,4.452,0,0,1,.5.186c.17.066.332.133.5.206.126.05.243.11.362.163s.253.116.369.176.253.126.369.193c.216.12.429.236.645.362.3.186.605.379.894.579.163.11.326.229.482.346.1.076.193.15.289.229.183.143.376.3.555.452.1.09.206.18.3.273.206.186.406.372.6.572.18.176.356.362.532.555a15.73,15.73,0,0,1,2.287,3.321c.066.126.133.259.2.386.083.176.163.356.246.532.066.163.133.319.19.482.06.123.106.266.156.4.073.183.143.376.2.569L90.811,78.6l.133.4.126.392h.007l4.6,14.177a30.03,30.03,0,0,1,.682,16.115",
    transform: "translate(23.843 114.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241294",
    "data-name": "Path 241294",
    d: "M84.615,166.406l-74.594-17.4.02-37.161L22.273,59.386a13.614,13.614,0,0,1,5.369-8.019c.239-.17.475-.326.718-.475.18-.113.339-.209.509-.3A10.575,10.575,0,0,1,30.033,50c.173-.08.369-.156.569-.236a13.778,13.778,0,0,1,1.765-.559c.16-.04.313-.073.472-.1l.5-.1c.123-.02.249-.037.372-.05.18-.027.4-.05.612-.073s.459-.04.685-.047.382-.01.535-.01a13.63,13.63,0,0,1,3.112.362l.279.067c.133.027.3.066.469.106l.369.11,37.164,8.641c.2.047.386.093.582.15a2.923,2.923,0,0,1,.362.1c.126.03.329.1.519.163l.382.133c.16.05.346.123.529.2s.349.14.525.219l1.16.562c.216.12.436.239.655.369q.494.3.948.608c.17.116.342.243.509.369.11.083.213.166.319.256.166.123.372.289.565.459.113.1.229.2.342.309.19.166.4.366.608.579.173.176.359.369.545.569a16.609,16.609,0,0,1,2.4,3.494l.519,1.091c.057.133.11.263.16.4a2.714,2.714,0,0,1,.1.263c.126.319.2.532.263.745L96.967,93.87a30.8,30.8,0,0,1,.7,16.534l-.206.874ZM11.58,147.775l71.868,16.757,12.671-54.37a29.343,29.343,0,0,0-.635-15.809L87.448,69.623c-.057-.186-.116-.356-.183-.522l-.057-.156c-.027-.07-.05-.136-.08-.2-.066-.18-.113-.289-.16-.4l-.459-.967a15.073,15.073,0,0,0-2.178-3.165c-.163-.176-.336-.356-.505-.525-.19-.2-.372-.369-.565-.539-.116-.113-.2-.19-.293-.266-.17-.146-.346-.293-.519-.419-.12-.1-.206-.166-.293-.233-.143-.11-.293-.219-.446-.322-.279-.2-.572-.379-.861-.555-.2-.116-.406-.233-.615-.346l-1.017-.492c-.183-.083-.332-.143-.489-.206s-.293-.12-.439-.163L77.882,60c-.146-.05-.3-.1-.455-.14a1.822,1.822,0,0,0-.286-.083c-.223-.06-.389-.1-.565-.146l-37.54-8.751c-.146-.033-.3-.07-.442-.1l-.306-.073a12.064,12.064,0,0,0-2.746-.319l-.409.007c-.259.007-.455.02-.645.04s-.4.043-.6.073c-.13.013-.223.027-.316.043l-.422.08c-.146.03-.276.057-.412.09a11.737,11.737,0,0,0-1.566.5c-.17.066-.342.136-.509.213a9.374,9.374,0,0,0-1.034.519c-.163.09-.3.173-.432.256-.246.15-.452.289-.662.436a12.045,12.045,0,0,0-4.748,7.1L11.58,112.113Z",
    transform: "translate(23.296 113.518)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241295",
    "data-name": "Path 241295",
    d: "M52.816,71.17c-.037.253-.09.5-.146.748a18.672,18.672,0,0,1-5.409,9.6l-2.62,2.474L27.119,100.545h-.007l-.755.725h-.01L10.4,116.337H10.4l-.14.14V64.734l5.35-5.054,5.772-5.453a18.684,18.684,0,0,1,10.373-5,17.943,17.943,0,0,1,2.736-.163h.076a18.928,18.928,0,0,1,3.641.4c.219.043.449.1.672.153l.047.017A18.792,18.792,0,0,1,52.816,71.17",
    transform: "translate(23.843 114.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241296",
    "data-name": "Path 241296",
    d: "M10.021,118.9V64.943L21.385,54.2A19.414,19.414,0,0,1,32.19,49a18.839,18.839,0,0,1,2.54-.173l.316,0a19.954,19.954,0,0,1,3.86.416c.16.033.329.073.5.113l.369.11a19.183,19.183,0,0,1,9.286,5.459,19.683,19.683,0,0,1,5.07,16.92,7.714,7.714,0,0,1-.156.791,19.408,19.408,0,0,1-5.629,9.991ZM11.58,65.614v49.6L47.268,81.5a17.887,17.887,0,0,0,5.183-9.2c.057-.243.1-.465.14-.695A18.148,18.148,0,0,0,47.926,56a17.9,17.9,0,0,0-8.651-5.064l-.239-.06c-.146-.037-.3-.073-.442-.1a17.944,17.944,0,0,0-3.5-.386l-.366,0a16.789,16.789,0,0,0-2.327.16,17.841,17.841,0,0,0-9.944,4.788Z",
    transform: "translate(23.296 113.52)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241297",
    "data-name": "Path 241297",
    d: "M51.657,47.545a9.666,9.666,0,0,0-5.7-4.967,1.778,1.778,0,0,0-.256-.09,10.489,10.489,0,0,0-1.882-.379A9.715,9.715,0,0,0,33.713,55.026l-8.877,15.53,10.676,12.87,8.535-15.48,1.689.509a4.808,4.808,0,0,0,5.931-3.544l.01-.02a4.048,4.048,0,0,0,.086-.612l.815-11.188.053-.675a3.072,3.072,0,0,0,.017-.5,9.471,9.471,0,0,0-.991-4.375",
    transform: "translate(57.737 97.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241298",
    "data-name": "Path 241298",
    d: "M36.037,84.709,24.646,70.975l8.94-15.64A10.274,10.274,0,0,1,44.315,41.956a10.948,10.948,0,0,1,1.982.4,2.781,2.781,0,0,1,.326.116,10.26,10.26,0,0,1,6.985,9.825,2.951,2.951,0,0,1-.023.559l-.861,11.829a4.574,4.574,0,0,1-.1.688l-.057.183a5.368,5.368,0,0,1-5.133,3.97,4.9,4.9,0,0,1-1.406-.206l-1.287-.389ZM25.906,70.865l9.958,12.009L44.235,67.69l2.091.628a3.766,3.766,0,0,0,1.107.163A4.356,4.356,0,0,0,51.6,65.166l.043-.18c.023-.14.033-.259.043-.382l.864-11.866a2.134,2.134,0,0,0,.017-.429,8.995,8.995,0,0,0-.934-4.169,9.093,9.093,0,0,0-5.393-4.7,2.4,2.4,0,0,0-.229-.083,9.94,9.94,0,0,0-1.8-.362,9.2,9.2,0,0,0-9.565,12.228l.08.223Z",
    transform: "translate(57.296 97.431)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241299",
    "data-name": "Path 241299",
    d: "M34.444,51.536l-5.36-2.56L32.809,54.5Z",
    transform: "translate(67.615 113.856)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241300",
    "data-name": "Path 241300",
    d: "M56.48,107.76l-4.106-3.115-1.805-1.373c-2.656-2.018-7.1-5.383-7.1-5.383L37.954,93.7l0,0-.369-.319h-.007l-1.283-1.094L10.256,70.107v36.988c1.007.505,1.982.977,2.909,1.43.715.346,1.4.682,2.071,1,1.064.519,2.055.991,2.942,1.423,2.916,1.4,4.774,2.271,5.037,2.394l0,0,.033.017L35,122.272a1.283,1.283,0,0,1-.239,2.191,4.248,4.248,0,0,0-1.775,1.526,3.94,3.94,0,0,0-.638,2.693,3.3,3.3,0,0,0,.166.712,3.932,3.932,0,0,0,5.359,2.3L62.844,120.3c1.855-.854,2.982-5.632-6.364-12.541",
    transform: "translate(23.843 162.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241301",
    "data-name": "Path 241301",
    d: "M36.782,134.014h0a4.731,4.731,0,0,1-4.462-3.185,4.413,4.413,0,0,1-.2-.861,4.707,4.707,0,0,1,.761-3.225,5,5,0,0,1,2.1-1.809.5.5,0,0,0,.293-.409.481.481,0,0,0-.2-.446l-11.743-8.9c-.721-.339-2.447-1.15-4.947-2.351l-5.273-2.547c-.851-.416-1.742-.848-2.66-1.307l-.432-.216V69.6L39.006,94.286,57.5,108.317c7.331,5.423,8.106,9.349,7.913,11.2a3.18,3.18,0,0,1-1.7,2.666l-24.972,11.4a4.651,4.651,0,0,1-1.958.429M24.065,113.8l.166.086,11.783,8.944a2.06,2.06,0,0,1-.386,3.518,3.485,3.485,0,0,0-1.45,1.25,3.151,3.151,0,0,0-.515,2.158,2.718,2.718,0,0,0,.13.555,3.171,3.171,0,0,0,2.989,2.141,3.094,3.094,0,0,0,1.31-.289l24.972-11.394a1.662,1.662,0,0,0,.795-1.41c.1-.958-.136-4.5-7.3-9.795L37.613,95.151l-1.28-1.1L11.58,72.975v34.82c.761.376,1.5.738,2.214,1.084l5.27,2.543c2.607,1.253,4.372,2.081,4.894,2.327Z",
    transform: "translate(23.296 161.803)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241302",
    "data-name": "Path 241302",
    d: "M48.6,50.661s-6.713,5.3-14.715,5.775a49.933,49.933,0,0,1-7.3.186l2.919-7.6a9.756,9.756,0,0,1,12.149-6.543A9.9,9.9,0,0,1,48.6,50.661",
    transform: "translate(61.792 97.793)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241303",
    "data-name": "Path 241303",
    d: "M33.936,49.2a3.2,3.2,0,1,1-2.144-3.986A3.2,3.2,0,0,1,33.936,49.2",
    transform: "translate(64.33 104.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241304",
    "data-name": "Path 241304",
    d: "M32.02,49.991l1.622.123.236-3.069L33.3,47l-.19,2.494-1.047-.08Z",
    transform: "translate(74.437 109.261)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241305",
    "data-name": "Path 241305",
    d: "M33.592,50.391l.043-.579a3.78,3.78,0,0,1-2.523-1.7l-.5.306a4.317,4.317,0,0,0,2.976,1.972",
    transform: "translate(71.175 111.853)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24864",
    "data-name": "Rectangle 24864",
    width: 480.569,
    height: 2.806,
    transform: "translate(0 516.194)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241306",
    "data-name": "Path 241306",
    d: "M210.561,488.627H38.349A29.007,29.007,0,0,1,9.374,459.655V38.636A29.007,29.007,0,0,1,38.349,9.664H210.561a29,29,0,0,1,28.972,28.972v421.02a29,29,0,0,1-28.972,28.972M38.349,12.576A26.088,26.088,0,0,0,12.29,38.636v421.02a26.088,26.088,0,0,0,26.059,26.059H210.561a26.088,26.088,0,0,0,26.059-26.059V38.636a26.088,26.088,0,0,0-26.059-26.059Z",
    transform: "translate(21.792 22.466)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241307",
    "data-name": "Path 241307",
    d: "M182.267,57.62H64.585a28.693,28.693,0,1,1,0-57.385H182.267a28.693,28.693,0,1,1,0,57.385",
    transform: "translate(83.44 0.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241308",
    "data-name": "Path 241308",
    d: "M186.677,58.948H61.264A25.636,25.636,0,0,1,35.657,33.341V25.607A25.636,25.636,0,0,1,61.264,0H186.677a25.639,25.639,0,0,1,25.611,25.607v7.733a25.639,25.639,0,0,1-25.611,25.607M61.264,1.559A24.076,24.076,0,0,0,37.216,25.607v7.733A24.076,24.076,0,0,0,61.264,57.389H186.677a24.074,24.074,0,0,0,24.048-24.048V25.607A24.074,24.074,0,0,0,186.677,1.559Z",
    transform: "translate(82.894)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241309",
    "data-name": "Path 241309",
    d: "M133.207,79.551H88.293a28.694,28.694,0,0,1,0-57.388h44.914a28.694,28.694,0,0,1,0,57.388",
    transform: "translate(138.564 51.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241310",
    "data-name": "Path 241310",
    d: "M137.62,80.877H84.976A25.636,25.636,0,0,1,59.369,55.27V47.536A25.636,25.636,0,0,1,84.976,21.929H137.62a25.636,25.636,0,0,1,25.607,25.607V55.27A25.636,25.636,0,0,1,137.62,80.877M84.976,23.488A24.076,24.076,0,0,0,60.928,47.536V55.27A24.076,24.076,0,0,0,84.976,79.317H137.62A24.076,24.076,0,0,0,161.668,55.27V47.536A24.076,24.076,0,0,0,137.62,23.488Z",
    transform: "translate(138.018 50.979)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241311",
    "data-name": "Path 241311",
    d: "M115.491,31.1H71.551a2.164,2.164,0,1,1,0-4.329h43.94a2.164,2.164,0,0,1,0,4.329",
    transform: "translate(161.307 62.227)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241312",
    "data-name": "Path 241312",
    d: "M126.371,34.472h-59.5a2.164,2.164,0,1,1,0-4.329h59.5a2.164,2.164,0,0,1,0,4.329",
    transform: "translate(150.428 70.075)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241313",
    "data-name": "Path 241313",
    d: "M100.135,38.1H67.057a2.351,2.351,0,1,1,0-4.7h33.078a2.351,2.351,0,1,1,0,4.7",
    transform: "translate(150.425 77.651)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241314",
    "data-name": "Path 241314",
    d: "M155.968,9.1H51.72a2.164,2.164,0,0,1,0-4.329H155.968a2.164,2.164,0,0,1,0,4.329",
    transform: "translate(115.205 11.103)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241315",
    "data-name": "Path 241315",
    d: "M174.068,12.481H43.934a2.164,2.164,0,1,1,0-4.329H174.068a2.164,2.164,0,1,1,0,4.329",
    transform: "translate(97.105 18.951)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241316",
    "data-name": "Path 241316",
    d: "M163.51,15.858H43.932a2.164,2.164,0,0,1,0-4.329H163.51a2.164,2.164,0,1,1,0,4.329",
    transform: "translate(97.107 26.802)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241317",
    "data-name": "Path 241317",
    d: "M123.281,69.356,121,54.5,118.9,40.84l-6.792,1.446H112.1l-10.908.549-4.851.239-.06.432-.249,1.646-1.726,11.62a4.6,4.6,0,0,0,2.015,4.635,4.881,4.881,0,0,0,3.764.682l3.451-.735,2.68,19.656Z",
    transform: "translate(219.098 94.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241318",
    "data-name": "Path 241318",
    d: "M106.181,82.348l-2.716-19.932-2.906.615a5.4,5.4,0,0,1-4.159-.758,5.093,5.093,0,0,1-2.241-5.143l2.095-14.117,16.188-.808,7.255-1.553,4.512,29.384Zm-1.839-21.182,2.643,19.377,16.1-10.992L118.838,41.9l-6.257,1.333-15.42.785L95.186,57.286a4.083,4.083,0,0,0,1.785,4.123,4.408,4.408,0,0,0,3.371.608Z",
    transform: "translate(218.734 94.506)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241319",
    "data-name": "Path 241319",
    d: "M128.748,54.552l-1.938-6.507s-14.609-1.12-21.588,1.337-9.176,7.7-9.176,7.7Z",
    transform: "translate(223.283 111.101)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241320",
    "data-name": "Path 241320",
    d: "M95.681,58.5l.5-1.177c.093-.226,2.414-5.589,9.635-8.129,3.085-1.084,7.893-1.636,14.29-1.636,4.212,0,7.58.253,7.614.256l.535.043,2.367,7.946Zm24.42-9.382c-6.134,0-10.9.535-13.771,1.546a15.811,15.811,0,0,0-8.036,6.071L128.569,54.4l-1.506-5.064c-1.1-.07-3.787-.216-6.962-.216",
    transform: "translate(222.434 110.556)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241321",
    "data-name": "Path 241321",
    d: "M58.61,86.661a2.885,2.885,0,0,0,.778-.153,3.493,3.493,0,0,0,2.3-3.215,1.087,1.087,0,0,1,1.626-.914l12.019,6.9L85.65,71.3l-6.177-3.554s-.213-.116-.565-.322c-1.7-.977-6.736-3.86-7.627-4.369l-3.77-2.171c-8.458-4.99-11.8-2.54-11.846-.811l-.522,19.576-.1,3.607a3.32,3.32,0,0,0,3.564,3.408",
    transform: "translate(127.965 134.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241322",
    "data-name": "Path 241322",
    d: "M76.167,90.883,63.324,83.558a.314.314,0,0,0-.309.306,4.3,4.3,0,0,1-2.833,3.93,3.905,3.905,0,0,1-.984.193c-.086,0-.183.007-.276.007a4.1,4.1,0,0,1-4.109-4.216l.618-23.183c.037-1.446,1.5-2.909,4.236-2.909,2.377,0,5.333,1.034,8.784,3.072l3.764,2.164c.888.509,5.925,3.388,7.627,4.369.339.2.539.306.545.309l6.872,3.956ZM63.324,82a1.853,1.853,0,0,1,.924.249l11.341,6.507,9.542-16.627-5.5-3.165s-.223-.116-.575-.326c-1.7-.974-6.726-3.853-7.617-4.362L67.666,62.1c-4-2.364-6.56-2.859-8-2.859-1.925,0-2.663.851-2.676,1.39l-.618,23.187a2.538,2.538,0,0,0,2.55,2.613l.18,0a2.282,2.282,0,0,0,.585-.116,2.706,2.706,0,0,0,1.769-2.494A1.869,1.869,0,0,1,63.324,82",
    transform: "translate(127.421 134.103)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241323",
    "data-name": "Path 241323",
    d: "M75.583,64.467l-6.952-4L58.687,81.823l5.486,2.527Z",
    transform: "translate(136.433 140.565)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241324",
    "data-name": "Path 241324",
    d: "M65.217,86.124l-6.842-3.152L69.008,60.134l8.365,4.814ZM60.45,82.21l4.126,1.9L75.245,65.523,69.7,62.332Z",
    transform: "translate(135.707 139.796)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241325",
    "data-name": "Path 241325",
    d: "M297.207,132.42,278.844,106,254.9,71.563a44.174,44.174,0,0,0-4.05-7.447c-7.527-10.938-18.881-14.7-35.279-14.7H186.785a32.387,32.387,0,0,0-24.43,11.1L126.73,97.227,113.943,110.4,73.793,90.155,59.457,115.138s29.394,29.161,45.386,39.717a21.821,21.821,0,0,0,6.719,3.571c9.569,3.624,18.343.362,23.995-6.915l21.069-21.7,3.178-3.278,5.888,47.956H271.819l-1.34-9.21a22.056,22.056,0,0,0,26.728-32.859",
    transform: "translate(138.223 114.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241326",
    "data-name": "Path 241326",
    d: "M273.4,175.813H165.685l-5.775-47.022L136.8,152.6c-4.3,5.549-10.277,8.638-16.77,8.638a22.8,22.8,0,0,1-8.059-1.536,22.585,22.585,0,0,1-6.925-3.687c-15.822-10.44-45.16-39.488-45.456-39.781l-.426-.422,15-26.139,40.3,20.321L162.48,60.511A33.242,33.242,0,0,1,187.465,49.18h28.786c17.924,0,28.669,4.5,35.921,15.038a44.962,44.962,0,0,1,4.093,7.507l42.264,60.793a22.839,22.839,0,0,1-18.748,35.824,22.931,22.931,0,0,1-7.654-1.31Zm-106.335-1.559H271.6l-1.406-9.685,1.273.535a21.277,21.277,0,0,0,25.78-31.7L254.864,72.417a43.712,43.712,0,0,0-3.976-7.314c-6.929-10.067-17.289-14.366-34.637-14.366H187.465a31.717,31.717,0,0,0-23.842,10.832L114.786,111.9l-40-20.171L61.115,115.549c3.674,3.617,30.139,29.5,44.841,39.2a21.217,21.217,0,0,0,6.533,3.478c8.764,3.321,17.412.718,23.134-6.649l25.438-26.212Z",
    transform: "translate(137.539 114.331)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241327",
    "data-name": "Path 241327",
    d: "M95.03,169.49h71l-2.314-20.354-51.962,0s-2.746,8.757-10.749,10.277c-7.245,1.373-5.978,10.074-5.978,10.074",
    transform: "translate(220.724 346.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241328",
    "data-name": "Path 241328",
    d: "M167.469,170.815H94.916l-.1-.668c-.475-3.265.293-9.755,6.6-10.952,7.457-1.413,10.127-9.658,10.15-9.745l.173-.545,53.229,0ZM96.3,169.256h69.424l-2.141-18.795-50.712,0c-.768,2.018-3.883,8.884-11.158,10.264-5.383,1.021-5.532,6.576-5.413,8.528",
    transform: "translate(220.164 346.16)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241329",
    "data-name": "Path 241329",
    d: "M240.08,297.866l-17.122-84.834L201.546,106.886l-4.013-19.852H91.41l14.31,103.393,14.257,103.087h51.966L167.62,222.72,164.7,175.013l4.891,15.094,34.927,107.758,5.18,16h33.6Z",
    transform: "translate(212.506 202.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241330",
    "data-name": "Path 241330",
    d: "M244.884,315.186H209.761l-5.356-16.534-37.922-117L173.4,294.839H119.923L91.141,86.8H198.8ZM210.9,313.627h32.084L197.52,88.358H92.93l28.35,204.918h50.46l-7.561-123.81Z",
    transform: "translate(211.88 201.786)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241331",
    "data-name": "Path 241331",
    d: "M121.146,47.124c-.449-6.071-4.425-8.987-10.829-8.987a10.649,10.649,0,0,0-6.743,2.281c-1.656-1.516-3.149-2.238-3.933-1.706-.539.362-.638,1.273-.4,2.484-2.613-1.742-4.907-2.447-5.685-1.573C92.5,40.8,94.6,44.4,98.238,47.652c.2.183.406.339.608.509-.1.4-.183.8-.246,1.2h-.01l-.063.432-.249,1.646c.07.166.126.339.193.515.971,2.637,3.2,4.5,5.958,5.8a30.114,30.114,0,0,0,7.813,2.3,1.485,1.485,0,0,0,.243.043,48.837,48.837,0,0,0,9.625.712Z",
    transform: "translate(216.855 88.659)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241332",
    "data-name": "Path 241332",
    d: "M121.517,62.159a54.162,54.162,0,0,1-8.611-.745,2.208,2.208,0,0,1-.309-.057A30.451,30.451,0,0,1,104.644,59c-3.258-1.539-5.4-3.637-6.354-6.234l-.266-.688.479-2.956L98.53,49c-.086-.073-.173-.146-.259-.223-3.458-3.092-6.417-7.268-4.748-9.133a2.064,2.064,0,0,1,1.619-.635,8.38,8.38,0,0,1,3.76,1.27,2.107,2.107,0,0,1,.854-1.672,1.844,1.844,0,0,1,1.054-.306,6.009,6.009,0,0,1,3.355,1.656,11.442,11.442,0,0,1,6.7-2.058c7.019,0,11.141,3.448,11.607,9.708L123.5,62.093l-.791.043s-.422.023-1.187.023M99.631,51.893l.05.136.07.19c.815,2.208,2.683,4.013,5.562,5.376a29.345,29.345,0,0,0,7.61,2.241l.239.04a52.3,52.3,0,0,0,8.664.725l-.908-12.877c-.406-5.482-3.79-8.262-10.051-8.262a9.881,9.881,0,0,0-6.261,2.115l-.519.409-.489-.446c-1.586-1.453-2.713-1.815-2.969-1.639-.1.07-.309.505-.076,1.689l.359,1.835-1.556-1.037a9.336,9.336,0,0,0-4.216-1.815.675.675,0,0,0-.459.116c-.416.462.658,3.381,4.625,6.929.123.106.243.206.362.306l.6.5-.113.472c-.093.379-.176.761-.236,1.134Z",
    transform: "translate(216.304 88.113)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241333",
    "data-name": "Path 241333",
    d: "M95.451,46.535c-.319,2.188.116,3.96.974,3.96s1.809-1.772,2.128-3.96-.116-3.96-.974-3.96-1.809,1.772-2.128,3.96",
    transform: "translate(221.657 98.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241334",
    "data-name": "Path 241334",
    d: "M131.6,169.491l-6.6-20.354H161.1l4.106,20.354Z",
    transform: "translate(290.607 346.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241335",
    "data-name": "Path 241335",
    d: "M166.907,170.815H131.785l-7.1-21.913h37.806Zm-33.989-1.559H165l-3.79-18.795H126.827Z",
    transform: "translate(289.857 346.16)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24865",
    "data-name": "Rectangle 24865",
    width: 56.271,
    height: 1.805,
    transform: "translate(336.298 332.405)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24866",
    "data-name": "Rectangle 24866",
    width: 1.807,
    height: 49,
    transform: "translate(400.774 231.811) rotate(-8.259)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24867",
    "data-name": "Rectangle 24867",
    width: 21.011,
    height: 1.805,
    transform: "translate(297.358 240.801) rotate(-47.315)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241336",
    "data-name": "Path 241336",
    d: "M197.533,87.034H91.41l1.533,11.095,106.844.06Z",
    transform: "translate(212.506 202.332)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241337",
    "data-name": "Path 241337",
    d: "M201.366,99.513,92.89,99.45,91.141,86.8H198.8ZM94.25,97.894l105.212.06-1.938-9.6H92.93Z",
    transform: "translate(211.88 201.786)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241338",
    "data-name": "Path 241338",
    d: "M112.14,100.42h1.19l3.86,44.665H116Z",
    transform: "translate(260.697 233.45)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/Contact_Us.727396d7024e106b7eae6f97e8fb67da.svg";
export { ForwardRef as ReactComponent };